import generateCrudConstants from './baseCrudConstants';

export default generateCrudConstants('CURRENT_USER', 'R', [
  'CHECK_USER_DATA_STARTED',
  'AUTHENTICATION_REQUEST',
  'AUTHENTICATION_SUCCESS',
  'AUTHENTICATION_FAILURE',
  'AUTHENTICATION_ERROR_RESET',
  'EMAIL_CHANGED',
  'EMAIL_CHECKED',
  'CONFIRMATION_RESENT',
  'CONFIRMATION_REQUEST',
  'PASSWORD_RESET',
]);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/constants/currentUserConstants.js